import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import zh from './locales/zh.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            zh: { translation: zh },
        },
        supportedLngs: ['zh', 'en'],
        // No `lng:` here — previous "lng: 'zh'" hard-forced Chinese and
        // disabled the language detector entirely, so the login + register
        // pages were Chinese-only for English-browser visitors with no way
        // to switch.
        //
        // Detection is intentionally localStorage-ONLY. We deliberately
        // skip htmlTag and navigator:
        //   • `<html lang="en">` is set in index.html (default for the
        //     SPA shell), so htmlTag detection would flip every existing
        //     Chinese user to English on their next visit. That's a worse
        //     regression than the bug we're fixing.
        //   • `navigator` detection (browser language) has the same
        //     flip-on-next-visit risk for users on English-region browsers.
        //
        // So: new visitors fall through to `fallbackLng: 'zh'` (preserves
        // existing default). Users who explicitly click the LanguageToggle
        // get their choice persisted to localStorage and respected on
        // every future visit.
        fallbackLng: 'zh',
        detection: {
            order: ['localStorage'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
